import React, { useState } from "react";
import ReadingsHeaderOptions from "./ReadingHeaderOptions";
import ReadingsTable from "./ReadingsTable";
import HealthScreeningReportModal from "./HealthScreeningReportModal";
import { useSelector } from "react-redux";
import { getReadingList } from "@src/redux/index";

const Readings: React.FC = () => {
  const { result: readingList } = useSelector(getReadingList);

  return (
    <div>
      <ReadingsHeaderOptions />
      <div
        className={
          (readingList?.items?.length ?? 0) > 4
            ? "reading-table-main-container"
            : "reading-table-main-length"
        }
      >
        <ReadingsTable />
      </div>
    </div>
  );
};

export default Readings;
